import _taggedTemplateLiteral from "/drone/src/node_modules/@babel/runtime/helpers/esm/taggedTemplateLiteral";

var _templateObject;

import styled from 'styled-components';
import { colorGrey00 } from '../../../tokens';
import { getComponentOverride } from '../../../system/mixins/getComponentOverride';
import { SearchSuggestionItemContainer } from '../SearchSuggestionItem/style';
import { getPropsBlocker } from '../../../utils';
export var SearchEmptySuggestionsListRoot = styled(SearchSuggestionItemContainer).withConfig(getPropsBlocker({}, false))(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n    cursor: default;\n\n    &:hover {\n        background-color: ", ";\n    }\n\n    ", ";\n"])), colorGrey00, getComponentOverride('SearchEmptySuggestionsList'));